module.exports = {"title":"Compass / Clinometer"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/geocompass/en/messages.json
// module id = 165
// module chunks = 0